import axios from 'axios';
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil';
import {ATIVAR_USUARIO_PLATAFORMA_WEB} from '../types';
import {URL} from '../../util/ambienteActions';

export default function ativarUsuarioPlataformaWeb(codigo) {
    const url = `${URL}/usuarios/plataforma-web/${codigo}/ativar`;


    return dispatch => axios.post(url, null, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: ATIVAR_USUARIO_PLATAFORMA_WEB,
            payload: response
        })
    );
}
